import { FunctionComponent } from "react";

import { format } from "date-fns";

import { ListPerson } from "../../../schema/list";

type Prospect = NonNullable<ListPerson["prospect"]>;

/**
 * Hover content for the CRM contact icons in the person identity card.
 * Extracted from {@link ListPersonHeader} to keep that file within the
 * 500-line limit.
 */
export const CrmTooltip: FunctionComponent<{
	prospect: Prospect;
	crmProspect: NonNullable<Prospect["crmProspects"]>[number];
}> = ({ prospect, crmProspect }) => (
	<div className="flex flex-col gap-2">
		<span>Current Status: {crmProspect.currentStatus}</span>
		{crmProspect.lastUpdatedAt && (
			<span>
				Last Updated At: {format(new Date(crmProspect.lastUpdatedAt), "HH:mm dd.MM.yyyy")}
			</span>
		)}
		<span>Account Owner: {crmProspect.accountOwner}</span>
		<span>Reference ID: {crmProspect.referenceId}</span>
		{crmProspect.syncStatus && <span>Sync Status: {crmProspect.syncStatus}</span>}
		{crmProspect.syncError && <span>Sync Error: {crmProspect.syncError}</span>}
		{prospect.crmDeals && prospect.crmDeals.length > 0 && (
			<>
				<hr className="border-t border-gray-500 my-1" />
				<span className="font-semibold">Deals</span>
				{prospect.crmDeals.map((deal) => (
					<div key={deal.id} className="flex flex-col gap-1 ml-2">
						<span className="font-medium">
							{deal.url ? (
								<a
									className="text-inherit underline"
									href={deal.url}
									rel="noreferrer"
									target="_blank"
								>
									{deal.dealName}
								</a>
							) : (
								deal.dealName
							)}
						</span>
						{deal.pipeline && <span>Pipeline: {deal.pipeline}</span>}
						{deal.dealStage && <span>Stage: {deal.dealStage}</span>}
						{deal.dealOwner && <span>Owner: {deal.dealOwner}</span>}
						{deal.closeDate && (
							<span>Close Date: {format(new Date(deal.closeDate), "dd.MM.yyyy")}</span>
						)}
					</div>
				))}
			</>
		)}
	</div>
);

export const CrmLeadTooltip: FunctionComponent<{
	crmLead: NonNullable<Prospect["crmLeads"]>[number];
}> = ({ crmLead }) => (
	<div className="flex flex-col gap-2">
		<span>Lead: {crmLead.leadName}</span>
		{crmLead.pipeline && <span>Pipeline: {crmLead.pipeline}</span>}
		{crmLead.leadStage && <span>Stage: {crmLead.leadStage}</span>}
		{crmLead.leadOwner && <span>Owner: {crmLead.leadOwner}</span>}
		<span>Reference ID: {crmLead.referenceId}</span>
		{crmLead.syncStatus && <span>Sync Status: {crmLead.syncStatus}</span>}
		{crmLead.syncError && <span>Sync Error: {crmLead.syncError}</span>}
	</div>
);
